import { render, staticRenderFns } from "./TheTableAddresses.vue?vue&type=template&id=7205066c&scoped=true&"
import script from "./TheTableAddresses.vue?vue&type=script&lang=ts&"
export * from "./TheTableAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205066c",
  null
  
)

export default component.exports